export const PARKING_ENDPOINTS = {
    PARKING_INFO: '/eifapi/parking',
    GET_CAR_PARKING_LIST: '/api-dept/get-carListParking',
    GET_PARKING_FEE: '/api-dept/get-feeParking',
    GET_AREA_INFO: '/api-dept/get-areaInfo',
};
